import styled from 'styled-components'

import { ComponentIcon } from 'features/VehicleTemplates/components/Components/Icon'
import { PropertyIcon } from 'features/VehicleTemplates/components/Properties/Icon'
import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'
import { SEAT_PROPERTIES, WC_PROPERTIES } from 'features/VehicleTemplates/components/Properties/constants'

const Wrapper = styled.div<TSFixMe>`
  margin-left: -28px;
`

const Table = styled.table<TSFixMe>`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;

  tbody:before {
    content: '@';
    display: block;
    line-height: 10px;
    text-indent: -99999px;
  }
`

const EmptyHeader = styled.th<TSFixMe>`
  width: 26px;
  min-width: 26px;
  max-width: 26px;
`

const ColumnHeader = styled.th<TSFixMe>`
  text-align: center;
  border: solid 1px rgba(153, 153, 189, 0.27);
  background-color: #f8f9fc;
  padding: 2px 0;
  font-size: 12px;
  font-weight: 500;
  color: #9999bd;
  border-right: none;

  ${(props): TSFixMe => {
    if (props.isFirst) {
      return `
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      `
    }
  }}

  :last-child {
    border-right: solid 1px rgba(153, 153, 189, 0.27);
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`

const RowHeader = styled.th<TSFixMe>`
  padding: 0;
  position: relative;
  vertical-align: baseline;

  > div {
    color: #9999bd;
    border-top: solid 1px rgba(153, 153, 189, 0.27);
    border-left: solid 1px rgba(153, 153, 189, 0.27);
    border-right: solid 1px rgba(153, 153, 189, 0.27);
    background-color: #f8f9fc;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: 500;
    width: 16px;
    position: absolute;
    height: calc(100% - 1px);
    display: flex;
    align-items: center;
    justify-content: center;

    ${(props): TSFixMe => {
      if (props.isFirstRow) {
        return `
          border-top-left-radius: 3px;
          border-top-right-radius: 3px;
        `
      }
    }}

    ${(props): TSFixMe => {
      if (props.isLastRow) {
        return `
          border-bottom-left-radius: 3px;
          border-bottom-right-radius: 3px;
          border-bottom: solid 1px rgba(153, 153, 189, 0.27);
          height: calc(100% - 2px);
        `
      }
    }}
  }
`

const Cell = styled.td<TSFixMe>`
  text-align: center;
  border-top: solid 1px rgba(153, 153, 189, 0.27);
  border-left: solid 1px rgba(153, 153, 189, 0.27);
  padding: 10px;
  background-color: #f8f9fc;

  :last-child {
    border-right: solid 1px rgba(153, 153, 189, 0.27);
  }

  ${(props): TSFixMe => {
    let borderStyle = ''

    if (props.isFirstRow) {
      if (props.isFirstCell) {
        borderStyle = `
          ${borderStyle}
          border-top-left-radius: 3px;
        `
      }

      if (props.isLastCell) {
        borderStyle = `
          ${borderStyle}
          border-top-right-radius: 3px;
        `
      }
    }

    if (props.isLastRow) {
      borderStyle = `
        ${borderStyle}
        border-bottom: solid 1px rgba(153, 153, 189, 0.27);
      `

      if (props.isFirstCell) {
        borderStyle = `
          ${borderStyle}
          border-bottom-left-radius: 3px;
        `
      }

      if (props.isLastCell) {
        borderStyle = `
          ${borderStyle}
          border-bottom-right-radius: 3px;
        `
      }
    }

    return borderStyle
  }}
`

const CellContent = styled.div<TSFixMe>`
  background-color: #ffffff;
  height: 85px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;

  > div {
    height: 0;
    flex: 1 0 auto;
  }
`

const VehicleComponentIcon = styled(ComponentIcon)<TSFixMe>`
  margin-top: 2px;
  fill: #9999bd;

  ${(props): TSFixMe => {
    switch (props.component) {
      case VEHICLE_COMPONENT.SEAT:
        return `
          width: 26px;
          height: 29px;
        `
      case VEHICLE_COMPONENT.DRIVER:
        return `
          width: 27px;
          height: 27px;
        `
      case VEHICLE_COMPONENT.DOOR:
        return `
          width: 23px;
          height: 23px;
        `
      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
      case VEHICLE_COMPONENT.STAIR:
        return `
          width: 23px;
          height: 23px;
        `
      case VEHICLE_COMPONENT.WC:
        return `
          width: 19px;
          height: 26px;
        `
    }
  }}
`

const Properties = styled.div<TSFixMe>`
  display: flex;
  margin: -1px;
  flex-wrap: wrap;
`

const PropertyIconWrapper = styled.div<TSFixMe>`
  margin: 1px;
  padding: 0 2px;
  border-radius: 2px;
  border: solid 1px rgba(153, 153, 189, 0.27);
  background-color: #f8f9fc;
  display: flex;
  align-items: center;
  justify-content: center;
  width: calc(100% / 3 - 8px);
  min-height: 21px;
  max-height: 21px;
`

const VehiclePropertyIcon = styled(PropertyIcon)<TSFixMe>`
  fill: #9999bd;

  ${(props): TSFixMe => {
    if (props.component === VEHICLE_COMPONENT.SEAT) {
      switch (props.property) {
        case SEAT_PROPERTIES.TV:
          return `
            width: 17px;
            height: 17px;
          `
        case SEAT_PROPERTIES.PLUG:
          return `
            width: 13px;
            height: 13px;
          `
        case SEAT_PROPERTIES.WOMEN:
          return `
            width: 13px;
            height: 16px;
          `
      }
    } else if (props.component === VEHICLE_COMPONENT.WC) {
      switch (props.property) {
        case WC_PROPERTIES.WOMEN:
          return `
            width: 8px;
            height: 20px;
          `
        case WC_PROPERTIES.MEN:
          return `
            width: 8px;
            height: 18px;
          `
      }
    }
  }}
`

const Label = styled.div<TSFixMe>`
  font-size: 12px;
  font-weight: 500;
  color: #65658d;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 2px 5px;
`

export const VehicleGrid = ({ grid = [], ...props }): TSFixMe => {
  const firstRow = grid[0]

  return (
    <Wrapper>
      <Table>
        <thead>
          <tr>
            <EmptyHeader />

            {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
            {firstRow.map((cell: TSFixMe, index: TSFixMe): TSFixMe => {
              return (
                <ColumnHeader key={index} isFirst={index === 0}>
                  {index + 1}
                </ColumnHeader>
              )
            })}
          </tr>
        </thead>

        <tbody>
          {grid.map((row, rowIndex): TSFixMe => {
            const isFirstRow = rowIndex === 0
            const isLastRow = rowIndex === grid.length - 1

            return (
              <tr key={rowIndex}>
                <RowHeader isFirstRow={isFirstRow} isLastRow={isLastRow}>
                  <div>{rowIndex + 1}</div>
                </RowHeader>

                {/* @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message*/}
                {row.map((cell: TSFixMe, cellIndex: TSFixMe): TSFixMe => {
                  const handleClick = (): TSFixMe => {
                    if (props.onClick) {
                      props.onClick(rowIndex, cellIndex)
                    }
                  }

                  return (
                    <Cell
                      key={cellIndex}
                      isFirstRow={isFirstRow}
                      isLastRow={isLastRow}
                      isFirstCell={cellIndex === 0}
                      // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                      isLastCell={cellIndex === row.length - 1}
                    >
                      <CellContent onClick={handleClick}>
                        <Properties>
                          {cell.properties.map((property: TSFixMe): TSFixMe => {
                            return (
                              <PropertyIconWrapper key={property}>
                                <VehiclePropertyIcon component={cell.component} property={property} />
                              </PropertyIconWrapper>
                            )
                          })}
                        </Properties>

                        <div>
                          <VehicleComponentIcon component={cell.component} />
                        </div>

                        {cell.label ? <Label>{cell.label}</Label> : <div />}
                      </CellContent>
                    </Cell>
                  )
                })}
              </tr>
            )
          })}
        </tbody>
      </Table>
    </Wrapper>
  )
}
